import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    // 用户token
    token: '',

    // 用户信息
    userInfo: {},

    // 图书馆token
    libraryToken: '',

    // 当前激活导航栏
    activeBar: 'TEXTBOOK',  // PRESS, LIBYARY, MY

    // 团体查询 or 个人查询
    searchType: 'GROUP',   // GROUP PERSON

    // 学校、专业、班级列表
    schoolOptions: [],
    collegeOptions: [],
    clsOptions: [],

    // 被选中的学校、专业、班级
    selectedSchool: '',
    selectedCollege: '',
    selectedCls: '',

    // 订单号
    wholesale_no: '',
    // 书号
    book_no: '',
    // 姓名
    name: '',
    // 学号
    student_num: '',

    // 用户会员等级 MEMBER:会员； ADMIN：管理员;
    memberType: 'MEMBER',

    // 申请退款订单
    redunderOrder: {},

    // 出版社查询
    pressParams: {},

    // 管理员订单查询
    adminOrderParams: {},

    // 支付二维码
    payQrcode: {},
    
    // 退款订单
    refundOrder: null,

    // 个人订单付款号码
    payOrderNo: '',

  },

  mutations: {

    /**
     * 更新state 字符串类型值
     * @param {*} state 
     * @param {*} payload 
     * {
     *      key: state对应的key
     *      val: 更新后的值
     * }
     */
    updateStrData(state, payload) {
      let key = payload.key
      let val = payload.val
      state[key] = val
    },

    // 设置学校、专业、班级
    setSchoolInfoList(state, payload) {
      switch (payload.type) {
        case 'SCHOOL':
          state.schoolOptions = payload.list
          break
        case 'COLLEGE':
          state.collegeOptions = payload.list
          break
        case 'CLS':
          state.clsOptions = payload.list
          break
        default:
          break
      }
    },

    // 设置被选中学校、专业、班级
    setSelectedSchoolInfo(state, payload) {
      switch (payload.type) {
        case 'SCHOOL':
          state.selectedSchool = payload.item
          break
        case 'COLLEGE':
          state.selectedCollege = payload.item
          break
        case 'CLS':
          state.selectedCls = payload.item
          break
        default:
          break
      }
    },

    // 存储用户信息
    setUserInfo(state, payload) {
      state.userInfo = Object.assign({}, payload)
    },

    // 更新申请退款订单
    setRefundOrder(state, payload) {
      state.refundOrder = Object.assign({}, payload)
    },

    // 更新出版社查询参数
    setPressParams(state, payload) {
      state.pressParams = Object.assign({}, payload)
    },

    // 更新管理员订单查询参数
    setAdminOrderParams(state, payload) {
      state.adminOrderParams = Object.assign({}, payload)
    },

    // 更新支付二维码
    setPayQrcode(state, payload) {
      state.payQrcode = Object.assign({}, payload)
    },

  }
})


// WEBPACK FOOTER //
// ./src/vuex/index.js